import { Auth } from 'aws-amplify';
import getStorage, {
  getLocalStorageItem,
  LOCAL_STORAGE,
  setLocalStorageItem,
} from '../StorageHelper';
import { SESSION_EXPIRED_ERROR } from '../../constants/CommonConstants';
import {
  LAST_SESSION_REFRESH_TIME,
  TOKEN_REFRESH_WAITING_TIME,
} from '../authUtils';

const getIdTokenFromStorage = () => {
  const localStorage = getStorage(LOCAL_STORAGE);
  const authConfig = JSON.parse(localStorage.getItem('authConfig') || '{}');
  const { userPoolWebClientId } = authConfig;
  const currentUser = localStorage.getItem(
    `CognitoIdentityServiceProvider.${userPoolWebClientId}.LastAuthUser`
  );

  if (currentUser) {
    return localStorage.getItem(
      `CognitoIdentityServiceProvider.${userPoolWebClientId}.${currentUser}.idToken`
    );
  }
  return null;
};

const isTokenExpired = (payload) => {
  if (!payload || !payload.exp) return true;
  return Date.now() >= payload.exp * 1000;
};

const parseTokenPayload = (token) => {
  if (!token) return null;
  const tokenPayload = token.split('.')[1];
  return tokenPayload ? JSON.parse(atob(tokenPayload)) : null;
};

const getTimeDifferenceWithCurrentTime = (time) => {
  const currentTime = Date.now();
  const millisecondsPassed = currentTime - time;
  const secondsPassed = Math.floor(millisecondsPassed / 1000);
  return secondsPassed;
};

class AuthHelper {
  static refreshPromise = null;

  getValidToken = async () => {
    try {
      const lastRefreshTokenAt = getLocalStorageItem(LAST_SESSION_REFRESH_TIME);

      if (
        getTimeDifferenceWithCurrentTime(lastRefreshTokenAt) <
        TOKEN_REFRESH_WAITING_TIME
      ) {
        await AuthHelper.refreshPromise;
        return this.getValidToken();
      }

      const existingToken = getIdTokenFromStorage();

      if (!existingToken || isTokenExpired(parseTokenPayload(existingToken))) {
        return this.refreshAccessToken();
      }
      return existingToken;
    } catch (error) {
      throw new Error(SESSION_EXPIRED_ERROR);
    }
  };

  refreshAccessToken = async () => {
    const lastRefreshTokenAt = getLocalStorageItem(LAST_SESSION_REFRESH_TIME);
    const shouldTokenRefresh =
      getTimeDifferenceWithCurrentTime(lastRefreshTokenAt) >
      TOKEN_REFRESH_WAITING_TIME;

    if (shouldTokenRefresh) {
      AuthHelper.refreshPromise = new Promise((resolve, reject) => {
        Auth.currentSession()
          .then(({ idToken }) => {
            const { jwtToken } = idToken;
            resolve(jwtToken);
          })
          .catch((error) => {
            reject(error);
          });
      });
      setLocalStorageItem(LAST_SESSION_REFRESH_TIME, Date.now());
    }

    return AuthHelper.refreshPromise;
  };
}

export default AuthHelper;
